import { FlagComponent } from './components/flag.component'
export { FlagComponent } 
export default FlagComponent
